import { render, staticRenderFns } from "./EvaluateTDC.vue?vue&type=template&id=6353310d"
import script from "./EvaluateTDC.vue?vue&type=script&lang=js"
export * from "./EvaluateTDC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports